import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Colors from '@components/moodboard/colors/Colors';
import Fabrics from '@components/moodboard/Fabrics';
import Images from '@components/moodboard/Images';
import MoodboardItem from '@components/moodboard/MoodBoardItem';
import SelectedFabric from '@components/moodboard/SelectedFabric';
import TopDetails from '@components/TopDetails';
import CollectionRequestDetails from '@components/CollectionRequestDetails';

import { fetchMoodBoardDetails } from '@store/actions/MoodboardAction';
import { fetchAllSuppliersMaterials } from '@store/supplier/action';

import { MATERIALS_TYPE } from '@/constants/constant';

const MoodBoard = ({ moodboardId, isShowTop = false }) => {
	const [activeTab, setActiveTab] = useState('MOODBOARD');
	const { moodboardImageList, productImageList, colorResponseList, materialResponseList, ...rest } =
		useSelector((store) => store.moodboardStore);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(fetchMoodBoardDetails(moodboardId));
	}, [moodboardId]);

	return (
		<div>
			<div className="common-moodboard-container">
				{isShowTop && <CollectionRequestDetails details={rest} />}
				{!isShowTop && (
					<TopDetails
						type={'MOODBOARD'}
						moodboardId={moodboardId}
						description={rest?.description}
						documentLists={rest?.fileList}
					/>
				)}
				<div className="moodboard-and-images-layout">
					<div className="left-half">
						<div className="moodboard-tab">
							<ul>
								<li
									className={activeTab === 'MOODBOARD' ? 'active' : ''}
									onClick={() => {
										dispatch(
											fetchAllSuppliersMaterials(
												0,
												8,
												MATERIALS_TYPE.FABRIC,
												'id,desc',
												{}
											)
										);
										setActiveTab('MOODBOARD');
									}}
								>
									Moodboard
								</li>
								<li
									className={activeTab === 'IMAGE' ? 'active' : ''}
									onClick={() => setActiveTab('IMAGE')}
								>
									Images
								</li>
							</ul>
						</div>
						{activeTab === 'MOODBOARD' ? (
							<MoodboardItem
								moodboardImageList={moodboardImageList}
								moodboardId={moodboardId}
							/>
						) : (
							<Images productImageList={productImageList} moodboardId={moodboardId} />
						)}
					</div>
					<div className="right-half">
						<Colors moodboardId={moodboardId} colorResponseList={colorResponseList} />
						<SelectedFabric materials={materialResponseList} moodboardId={moodboardId} />
						<Fabrics
							moodboardId={moodboardId}
							selectedFabrics={materialResponseList?.map((item) => item.id)}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MoodBoard;
